var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectColumns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6782_6775)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.17188H13C13.5523 2.17188 14 2.61959 14 3.17188V5.17188H10H9H6H5H2V3.17187C2 2.61959 2.44772 2.17188 3 2.17188ZM15 5.17188V6.17188H14H11H9V9.17188V10.1719H8H6V11.1719V13.1719V14.1719H5H3C1.89543 14.1719 1 13.2764 1 12.1719V6.17188V5.17188V3.17187C1 2.06731 1.89543 1.17188 3 1.17188H13C14.1046 1.17188 15 2.06731 15 3.17188V5.17188ZM8 6.17188H6V9.17188H8V6.17188ZM5 6.17188H2V9.17188H5V6.17188ZM2 12.1719V10.1719H5V13.1719H3C2.44772 13.1719 2 12.7242 2 12.1719ZM15.8538 8.48794C16.0487 8.68292 16.0487 8.99787 15.8538 9.19284L14.9389 10.1077L13.0642 8.23298L13.979 7.3181C14.174 7.12313 14.489 7.12313 14.6839 7.3181L15.8538 8.48794ZM7 16.1719V14.2971L12.5292 8.7679L14.404 10.6426L8.87474 16.1719H7Z",
    fill: "#CE690B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6782_6775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.171875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectColumns);
export default __webpack_public_path__ + "static/media/select_columns.4bcf24c687f958a3dbff8645da603095.svg";
export { ForwardRef as ReactComponent };